<template>
    <div
        class="avatar"
        :class="{'avatar--inline': inline}"
        :style="'height:'+size+'px;width:'+size+'px;font-size:'+size+'px;line-height:'+size+'px;'">
        <img
            v-if="profile_photo"
            :src="profile_photo"
            alt=""
            referrerpolicy="no-referrer"
            class="image">
        <span v-if="!profile_photo">{{ initial }}</span>
    </div>

</template>

<script>

import _ from 'lodash';
import userMixin from '../mixins/userMixin';

export default {
    mixins: [userMixin],
    props: {
        size: {
            type: Number,
            default: 24
        },
        inline: {
            type: Boolean,
            default: false
        }
    },

    mounted() {
        let id = this.userId;
        let userData = false;
        if (this.userdId !== 0) {
            userData = _.find(window.AR.data.users, user => (user.id ===  id));
            if (userData) {
                this.id = userData.id;
                this.profile_photo = userData.profile_photo;
                this.name = userData.name;
                this.email = userData.email;
            }
        }
    },

    computed: {
        fontSize() {
            return (this.size - 6);
        }
    }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/Avatar.vue